/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { PlayerTimestamp } from "../../../shared/types";

export const assetTimestampToSeconds = (timestamp: PlayerTimestamp): number => {
  const { Hour, Minute, Second } = timestamp;

  return (Hour ?? 0) * 3600 + (Minute ?? 0) * 60 + (Second ?? 0);
};
